import React from 'react';
import { observer } from 'mobx-react-lite';
import { useAppStateContext } from 'src/AppState/AppState';
import { lpBannerOptions } from '../LandingPageForm/selectionOptions';
import { UploadImg } from 'src/components/UploadImg/UploadImg';
import { OldSelect } from 'src/domains/layouts/shared/formComponents/Select/components/OldSelect';
import { OldInput } from 'src/domains/layouts/shared/formComponents/input/OldInput';
import { SectionHeaderLabel } from 'src/domains/layouts/shared/cms/form/Form.style';

export const Banners = observer(() => {
    const { landingPageState } = useAppStateContext();
    const { imgHTMLUrlStatus, imgHTMLUrl, imgHTMLUrlModel } = landingPageState;

    return (
        <>
            <SectionHeaderLabel>Banner Assets</SectionHeaderLabel>

            {landingPageState.isHTMLBannerType ? (
                <OldInput label='HTML5 Banner Link' status={imgHTMLUrlStatus} formInputState={imgHTMLUrl} model={imgHTMLUrlModel} />
            ) : (
                <UploadImg
                    title='Choose artwork for static banner'
                    uploadImageState={landingPageState.uploadImageState}
                />
            )}

            <OldSelect dataTest='set-banner' selectOptions={lpBannerOptions} stateValue={landingPageState.bannerType} />
        </>
    );
});
